<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Geräteinformation"}}</h4>
	</div>
</div>

{{#if noDeviceError}}
<div class="col-xs-12">
	<div class="alert alert-danger font-600">
		{{TR noDeviceError}}
	</div>
</div>
{{else}}

{{> WARNING_HINTS}}
<div class="card-box clearfix">
	<div class="col-xs-12 col-md-4">
		<div class="row">
			<div class="col-xs-12">
				<center>
					<img id="h-device-image" class="exposed-background clamp-width-500 p-10" src="{{deviceImg}}" onerror="this.onerror=null;this.src='../img/devices/{{deviceImg404}}';"/>
				</center>
			</div>
			{{#IF_AVAILABLE 'type'}}
			{{#if hasDlc}}
			<div id="h-device-manuals" class="col-xs-12 lg-m-t-15 sm-m-b-30">
				<center>
					{{#each dlc}}
					{{#if this.href }}
						<a class="btn btn-white" href="{{this.href}}" {{#if this.download}}download{{else}}target="_blank"{{/if}}><i class="fa fa-{{#if this.download}}download{{else}}external-link{{/if}}"></i>&nbsp;{{this.text}}</a>
					{{/if}}
					{{/each}}
				</center>
			</div>
			{{/if}}
			{{/IF_AVAILABLE}}
		</div>
		<div class="row">
			<div id='js-plugin' class="col-xs-12">
			</div>
		</div>
	</div>

	<div class="col-xs-12 col-md-8">
		<div class="row">
			<div class="col-xs-12">
				<dl class="dl-horizontal m-b-0">
					<div class="row {{#if readOnly}}m-b-15{{/if}}">
						<div class="col-xs-10 col-lg-11">
							<dt>{{TR "Name"}}</dt>
							<dd id="ct-device-name" class="font-600"><span style="white-space: pre">{{name}}</span></dd>
						</div>
						<div class="col-xs-2 col-lg-1">
							{{#unless readOnly}}
							<button class="btn btn-white pull-right js-modal_details"><i class="glyphicon glyphicon-pencil"></i></button>
							{{/unless}}
						</div>
					</div>
					{{#IF_AVAILABLE 'status'}}
					{{#if showStatus}}
					<dt class="hidden-xs">
						{{TR "Status"}}
					</dt>
					<dd id="h-status-l" class="hidden-xs">
						{{{DEVICE_STATUS status}}}
					</dd>
					<dt id="h-status-xs" class="visible-xs m-t-20">
						{{TR "Status"}} {{{DEVICE_STATUS status}}}
					</dt>
					{{/if}}
					{{/IF_AVAILABLE}}
				</dl>
			</div>
		</div>

		<div class="row">
			<div class="col-xs-12">
				<dl class="dl-horizontal m-b-0 m-t-15">
					{{#if type}}
					<dt>{{TR "Typ"}}</dt>
					<dd id="ct-type">{{TYPE_DEVICE deviceCategory type .}}</dd>
					{{/if}}
					{{#if infoConfig.attributes}}
					<div class="row m-t-15">
						<div class="col-xs-10 col-lg-11">
							{{#each infoConfig.attributes}}
								{{#DESCRIPTION @key ../this this}} {{/DESCRIPTION}}
							{{/each}}
						</div>
						<div class="col-xs-2 col-lg-1">
							{{#unless readOnly}}
							{{#unless noReinitialize}}
							{{#IF_AVAILABLE_ALL 'serial' 'firmware' 'hardware'}}
							<button class="btn btn-white pull-right js-reinitialize"><i class="fa fa-refresh"></i></button>
							{{/IF_AVAILABLE_ALL}}
							{{/unless}}
							{{/unless}}
						</div>
					</div>
					{{/if}}
					{{!-- Trovis I/O--}}
					{{#if trovisIO}}
					<div class="row m-t-15">
						<div class="col-xs-12">
							<div class="row">
								<div class="col-xs-10 col-lg-11">
									<dt>{{TR "Trovis I/O"}}</dt>
									<dd>
										<table class="column-h-padding-5">
											{{#each trovisIO}}
											<tr>
												<td>{{@key}}:</td>
												<td>{{#if this.firmware}}{{TR "Firmwareversion"}}: {{this.firmware}}{{else}}--{{/if}}</td>
												<td>{{#if name}}({{name}}){{/if}}</td>
											</tr>
											{{/each}}
										</table>
									</dd>
								</div>
							</div>
						</div>
					</div>
					{{/if}}

					<div class="row m-t-15">
						<div class="col-xs-12">
							{{#if showSimInfo}}
							<div class="row">
								<div class="col-xs-10 col-lg-11">
									<dt>{{TR "IMSI"}}</dt>
									<dd id="ct-imsi">{{simInfo.Imsi}}</dd>
									<dt>{{TR "IMEI"}}</dt>
									<dd id="ct-imei">{{simInfo.Imei}}</dd>
								</div>
								<div class="col-xs-2 col-lg-1">
									{{#unless readOnly}}
									{{#COMPARE simInfo.Imsi ">" "214070000000000"}}
									{{#COMPARE simInfo.Imsi "<" "214080000000000"}}
									<button class="btn btn-white pull-right js-connection-infos"><i class="fa fa-info"></i></button>
									{{/COMPARE}}
									{{/COMPARE}}
									{{/unless}}
								</div>
							</div>
							<br>
							{{/if}}
							{{#if last_seen}}
							<dt>{{caption.lastContact}}</dt>
							<dd id="ct-last-seen">{{TIME last_seen}}</dd>
							{{/if}}
							{{#if registered}}
							<dt>{{caption.registered}}</dt>
							<dd id="ct-registered">{{TIME registered}}</dd>
							{{/if}}
							<br>
							{{#each infoConfig.connection}}
								{{#COMPARE @key "parent"}}
									{{#IF_AVAILABLE 'parent'}}
									{{#COMPARE ../id '!=' ../wired_to}}
									{{#DESCRIPTION  @key ../this this (DEVICE_LINK ../parent)}}{{/DESCRIPTION}}
									{{/COMPARE}}
									{{/IF_AVAILABLE}}
								{{else}}
									{{#DESCRIPTION @key ../this this}} {{/DESCRIPTION}}
								{{/COMPARE}}
							{{/each}}
						</div>
					</div>
				</dl>
			</div>
		</div>

		<div class="row m-b-15">
			<div class="col-xs-12">
				<dl class="dl-horizontal m-b-0 m-t-15">
					{{#if contractNr}}
					<div class="row m-t-15">
						<div class="col-xs-10 col-lg-11">
							<dt>{{TR "Vertragsnummer"}}</dt>
							<dd id="ct-contract-nr">{{contractNr}}</dd>
						</div>
						<div class="col-xs-2 col-lg-1">
							{{#if canEditContractNr}}
							<button class="btn btn-white pull-right js-modal_contract"><i class="glyphicon glyphicon-pencil"></i></button>
							{{/if}}
						</div>
					</div>
					{{/if}}
					<div class="row m-t-15">
						<div class="col-xs-10 col-lg-11">
							<dt>{{TR "Labels"}}</dt>
							<dd id="ct-labels">
								{{#if hasLabels}}
									{{#each publicLabels}}
									<a href="#search?filter=%7B%22tags%22%3A%5B%22{{this}}%22%5D%7D">
									<span class="label label-block label-tags">{{this}}</span>
									</a>
									{{#if @last}}<br>{{/if}}
									{{/each}}
									{{#each privateLabels}}
										<a href="#search?filter=%7B%22groups%22%3A%5B%22{{this}}%22%5D%7D">
										<span class="label label-block label-groups">{{this}}</span>
										</a>
									{{/each}}
								{{else}}
									{{TR "Keine Labels vorhanden"}}
								{{/if}}
							</dd>
						</div>
						<div class="col-xs-2 col-lg-1">
							<button class="btn btn-white pull-right js-modal_grouping"><i class="glyphicon glyphicon-pencil"></i></button>
						</div>
					</div>
					{{#if isEventLog}}
					<div class="row m-t-15">
						<div id="h-events" class="exposed-background col-xs-10 col-lg-11">
							<dt>{{TR "Ereignisse"}}</dt>
							<dd>
								<div class="timeline-2">
								{{{eventLog}}}
								</div>
								<a id="ct-event-list" href="{{categoryLink}}/{{id}}/status-log">{{TR "Vollständige Übersicht"}}</a>
							</dd>
						</div>
					</div>
					{{/if}}
				</dl>
			</div>
		</div>
	</div>
</div>
{{/if}}
